import { topicPartQuestionRepository } from "../../../providers/repositories/topicPartQuestionRepository";
import { TopicPartQuestionFormData } from "../entities/TopicPartQuestion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const addUpdateTopicPartQuestionUseCase = {
    async exec(
        data: TopicPartQuestionFormData,
        id: string | number | null,
    ): Promise<boolean> {
        try {
            await topicPartQuestionRepository.addUpdate(data, id);

            if (id) {
                toast.success(t("action.updateSuccess"));
            }
            return true;
        } catch (error) {
            Logger.error("updateTopicPartQuestionUseCase", error);
            toast.error(t("action.updateError"));
        }
        return false;
    },
};
